import { render, staticRenderFns } from "./SpeakerOnSVG.vue?vue&type=template&id=17052ca6&"
import script from "./SpeakerOnSVG.vue?vue&type=script&lang=js&"
export * from "./SpeakerOnSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports